import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { NavBreadCrumbs } from '../../common/BreadCrumbs';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const BreadcrumbsWidget = () => {
    const descendingNodes = [
        {
            name: 'Parent',
            type: '',
            pk: '',
            sk: '',
            id: '',
        },
        {
            name: 'Node',
            type: '',
            pk: '',
            sk: '',
            id: '',
        },
        {
            name: 'Child',
            type: '',
            pk: '',
            sk: '',
            id: '',
        },
    ];
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "NavBreadCrumbs" }), _jsx(NavBreadCrumbs, { descendingNodes: descendingNodes })] })), []);
    return {
        name: 'BreadCrumbs',
        category: 'common',
        component,
    };
};
